import styled from 'styled-components';

const View = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1kvzvwy-0"
})(["background-color:", ";display:flex;flex-direction:column;height:100vh;height:-webkit-fill-available;width:100vw;position:fixed;top:0px;left:0px;right:0px;overflow:hidden;@media (prefers-reduced-motion:no-preference){transition:", ";}opacity:", ";z-index:", ";"], ({
  theme
}) => theme.surface.default, ({
  $fadeDuration
}) => `opacity ${$fadeDuration}ms ease-in-out`, ({
  $fadeState
}) => {
  if ($fadeState === 'entered') {
    return 1;
  }
  return 0;
}, ({
  theme
}) => theme.elevation.zIndex.layer4);
View.displayName = 'View';

export { View as V };
//# sourceMappingURL=View-D64ZsWTO.js.map
